import { render, staticRenderFns } from "./RegistroWeb.vue?vue&type=template&id=ca6bed7c&scoped=true"
import script from "./RegistroWeb.vue?vue&type=script&lang=js"
export * from "./RegistroWeb.vue?vue&type=script&lang=js"
import style0 from "./RegistroWeb.vue?vue&type=style&index=0&id=ca6bed7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6bed7c",
  null
  
)

export default component.exports